import { createTheme } from '@mui/material';

declare module '@mui/material/styles' {
  interface PaletteColor {
    lightest?: string;
  }

  interface SimplePaletteColorOptions {
    lightest?: string;
  }

  interface TypographyVariants {
    tableHeader: React.CSSProperties;
  }

  interface TypographyVariantsOptions {
    tableHeader?: React.CSSProperties;
  }
}

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    tableHeader: true;
  }
}

declare module '@mui/material/Button' {
  interface ButtonPropsVariantOverrides {
    secondaryContained: true;
  }
}

let customTheme = createTheme({
  palette: {
    mode: 'light',
    // primary: {
    //   main: '#15993E',
    //   light: "#1FB14A",
    //   dark: "#0E6E2D",
    //   lightest: "#C8F5D6"
    // },
    primary: {
      main: '#22438C',
      light: '#385FB5',
      dark: '#172E63',
      lightest: '#D6E3FA'
    },
    secondary: {
      lightest: '#FFFFFF', // Pure White (Surface / Cards)
      light:'#F7F7F7', // Subtle Off-White (Hover states / Elevation)
      main:'#E5E5E5', // Base Neutral (Container / App background)
      dark:'#D6D6D6', // Medium Gray (Borders / Dividers / Active states)
    },
    error: {
      main: '#CD020C',
      light: "#E1141F",
      dark: "#8B0108",
      lightest: "#FADBDC"
    },
    warning: {
      main: '#DC8400',
      light: "#F09200",
      dark: "#965A00",
      lightest: "#FFE8C2"
    },
    success: {
      main: '#15993E',
      light: "#1FB14A",
      dark: "#0E6E2D",
      lightest: "#C8F5D6"
    }
  },
  typography: {
  fontFamily: "Inter",
  h1: {
    fontSize: '2rem', // 32px
    fontWeight: 600,
    lineHeight: 1.25,
  },
  h2: {
    fontSize: '1.75rem', // 28px
    fontWeight: 600,
    lineHeight: 1.3,
  },
  h3: {
    fontSize: '1.5rem', // 24px
    fontWeight: 600,
    lineHeight: 1.35,
  },
  h4: {
    fontSize: '1.25rem', // 20px
    fontWeight: 600,
    lineHeight: 1.4,
  },
  h5: {
    fontSize: '1.125rem', // 18px
    fontWeight: 500,
    lineHeight: 1.45,
  },
  h6: {
    fontSize: '1rem', // 16px
    fontWeight: 500,
    lineHeight: 1.5,
  },
  subtitle1: {
    fontSize: '1rem', // 16px
    fontWeight: 500,
    lineHeight: 1.5,
  },
  subtitle2: {
    fontSize: '0.875rem', // 14px
    fontWeight: 500,
    lineHeight: 1.57,
  },
  body1: {
    fontSize: '1rem', // 16px
    fontWeight: 400,
    lineHeight: 1.5,
  },
  body2: {
    fontSize: '0.875rem', // 14px
    fontWeight: 400,
    lineHeight: 1.43,
  },
  button: {
    fontSize: '0.875rem', // 14px
    textTransform: 'none', // Modern UI standard (disables all-caps)
    fontWeight: 500,
    lineHeight: 1.43,
  },
  caption: {
    fontSize: '0.75rem', // 12px
    fontWeight: 400,
    lineHeight: 1.4,
  },
  overline: {
    fontSize: '0.75rem', // 12px
    fontWeight: 600,
    lineHeight: 1.5,
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
  },
  tableHeader: {
    fontSize: '1rem', // 16px
    fontWeight: 600,
    lineHeight: 1.5,
  }
},
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          overflow: 'auto',
          boxShadow: "none", 
          border: "1px solid #DDDDDD"
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 20,
          fontSize: 14,
          fontWeight: 'bold',
        }
      },
    }
  },
});

customTheme = createTheme(customTheme, {
  components: {
     MuiButton: {
      styleOverrides: {
        contained: {
          backgroundColor: customTheme.palette.primary.main,
          color: customTheme.palette.secondary.lightest,
          ':hover': {
            backgroundColor: customTheme.palette.primary.light
          },
          '&.Mui-disabled': {
            backgroundColor: customTheme.palette.primary.lightest,
            color: customTheme.palette.secondary.lightest
          }
        },
        secondaryContained: {
          backgroundColor: customTheme.palette.secondary.main,
          color: customTheme.palette.primary.main,
          ':hover': {
            backgroundColor: customTheme.palette.secondary.light
          },
          '&.Mui-disabled': {
            backgroundColor: customTheme.palette.secondary.dark
          }
        },
        text: {
          color: customTheme.palette.primary.main
        }
      }
    },
    MuiBadge: {
      styleOverrides: {
        root: {
          justifyContent:"center",borderRadius: "4px",width:"105px",height: "26px",fontSize: "10px",fontWeight: "500",lineHeight: "10px",color:'white',padding: "8px 4px 8px 4px"
        }
      }
    },
    MuiPagination: {
      styleOverrides: {
        ul: {
          marginRight: '0px',
        },
      },
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: customTheme.palette.primary.main,
            color: customTheme.palette.secondary.lightest,
            '&:hover': {
              backgroundColor: customTheme.palette.primary.main
            },
          },
        },
      },
    },
  },
});

export default customTheme;
